@if (universityName !== null) {
  <fwc-header-page>
    <div class="motif-page-header-container">
      @if (universityHeader) {
        <h1>Health Insurance for {{universityName}}</h1>
        <h4>{{participationLabel}}</h4>
      }
      @if (!universityHeader) {
        <h1>{{pageTitle}}</h1>
        <h4>{{subTitle}}</h4>
      }
    </div>
  </fwc-header-page>
}
@if (breadcrumbs) {
  <div class="fwc-row">
    <div class="fwc-col-12">
      <ul class="fwc-breadcrumb top-xs btm-xs">
        @for (crumb of breadcrumbs; track crumb) {
          <li [ngClass]="{'active' : crumb.active}"><a href="javascript:;" (click)="navigateTo(participantId + '/' + crumb.path)">{{crumb.label}}</a></li>
        }
      </ul>
    </div>
  </div>
}
